import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=1b74e636&scoped=true"
import script from "./search-box.vue?vue&type=script&lang=js"
export * from "./search-box.vue?vue&type=script&lang=js"
import style0 from "./search-box.vue?vue&type=style&index=0&id=1b74e636&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b74e636",
  null
  
)

export default component.exports